import {
    EMPLOYEE_PLAN_SUCCESS,
    EMPLOYEE_PLAN_PENDING,
    SET_MESSAGE,
    EMPLOYEE_PLAN_FAIL,
    ADD_EMPLOYEE_PLAN_FAIL,
    ADD_EMPLOYEE_PLAN_SUCCESS,
    ADD_EMPLOYEE_PLAN_PENDING,
    RESET_ADD_EMPLOYEE_PLAN,
    UPDATE_PLAN_STATUS_FAIL,
    UPDATE_PLAN_STATUS_PENDING,
    UPDATE_PLAN_STATUS_SUCCESS,
    UPDATE_EMPLOYEE_PLAN_FAIL,
    UPDATE_EMPLOYEE_PLAN_SUCCESS,
    UPDATE_EMPLOYEE_PLAN_PENDING,
    APPROVE_EMPLOYEE_PLAN_FAIL,
    APPROVE_EMPLOYEE_PLAN_SUCCESS,
    APPROVE_EMPLOYEE_PLAN_PENDING,
    REJECT_EMPLOYEE_PLAN_FAIL,
    REJECT_EMPLOYEE_PLAN_SUCCESS,
    REJECT_EMPLOYEE_PLAN_PENDING,
    DELETE_PLAN_VISITS_FAIL,
    DELETE_PLAN_VISITS_PENDING,
    DELETE_PLAN_VISITS_SUCCESS,
    REJECT_PLAN_DETAIL_FAIL,
    REJECT_PLAN_DETAIL_SUCCESS,
    REJECT_PLAN_DETAIL_PENDING,
    CREATE_BULK_TASKS_SUCCESS,
    CREATE_BULK_TASKS_FAIL,
    CREATE_BULK_TASKS_PENDING
} from "../types";
import { toast } from 'react-toastify';
import UserService from "../../services/user.service";


export const getEmployeePlan = (employeeId, month, year) => async (dispatch) => {
    dispatch({
        type: EMPLOYEE_PLAN_PENDING,
        payload: { employeePlan: "isLoading" },
    });
    return await UserService.getEmployeePlan(employeeId, month, year).then(
        (data) => {
            data.data.status ?
                dispatch({
                    type: EMPLOYEE_PLAN_SUCCESS,
                    payload: { employeePlan: data.data },

                }) :
                dispatch({
                    type: EMPLOYEE_PLAN_FAIL,
                });
            return Promise.resolve();

        },
        (error) => {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();

            dispatch({
                type: EMPLOYEE_PLAN_FAIL,
            });

            dispatch({
                type: SET_MESSAGE,
                payload: message,
            });
            return Promise.reject();
        }
    ).catch((error) => {
        return Promise.reject();
    });
};
export const getRejectPlanDetails = (planId) => async (dispatch) => {
    dispatch({
        type: REJECT_PLAN_DETAIL_PENDING,
        payload: { rejectPlanDetails: "isLoading" },
    });
    return await UserService.getRejectPlanDetails(planId).then(
        (data) => {
            data.data.status ?
                dispatch({
                    type: REJECT_PLAN_DETAIL_SUCCESS,
                    payload: { rejectPlanDetails: data.data },

                }) :
                dispatch({
                    type: REJECT_PLAN_DETAIL_FAIL,
                });
            return Promise.resolve();

        },
        (error) => {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();

            dispatch({
                type: REJECT_PLAN_DETAIL_FAIL,
            });

            dispatch({
                type: SET_MESSAGE,
                payload: message,
            });
            return Promise.reject();
        }
    ).catch((error) => {
        return Promise.reject();
    });
};
//add employeePlan
export const addEmployeePlan = (body) => async (dispatch) => {
    dispatch({
        type: ADD_EMPLOYEE_PLAN_PENDING,
        payload: { addEmployeePlan: "isLoading" },
    });
    return await UserService.addPlan(body).then(
        (data) => {
            data.data.status ? toast.success(data.data.message, { autoClose: 2000 }) : toast.error(data.data.message, { autoClose: 2000 });
            data.data.status ?
                dispatch({
                    type: ADD_EMPLOYEE_PLAN_SUCCESS,
                    payload: { addEmployeePlan: data.data.status },
                }) :
                dispatch({
                    type: ADD_EMPLOYEE_PLAN_FAIL,
                    payload: { addEmployeePlan: data.data.status },
                });
            return Promise.resolve();
        },
        (error) => {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();

            dispatch({
                type: ADD_EMPLOYEE_PLAN_FAIL,
            });

            dispatch({
                type: SET_MESSAGE,
                payload: message,
            });

            return Promise.reject();
        }
    ).catch((error) => {
        dispatch({
            type: ADD_EMPLOYEE_PLAN_FAIL,
        });
    }).finally(() => {
        dispatch({
            type: ADD_EMPLOYEE_PLAN_FAIL,
        });
    });
};

//update employeePlan
export const updateEmployeePlan = (body) => async (dispatch) => {
    dispatch({
        type: UPDATE_EMPLOYEE_PLAN_PENDING,
        payload: { updateEmployeePlan: "isLoading" },
    });
    return await UserService.updatePlan(body).then(
        (data) => {
            data.data.status ? toast.success(data.data.message, { autoClose: 2000 }) : toast.error(data.data.message, { autoClose: 2000 });
            data.data.status ?
                dispatch({
                    type: UPDATE_EMPLOYEE_PLAN_SUCCESS,
                    payload: { updateEmployeePlan: data.data.status },
                }) :
                dispatch({
                    type: UPDATE_EMPLOYEE_PLAN_FAIL,
                    payload: { updateEmployeePlan: data.data.status },
                });
            return Promise.resolve();
        },
        (error) => {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();

            dispatch({
                type: UPDATE_EMPLOYEE_PLAN_FAIL,
            });

            dispatch({
                type: SET_MESSAGE,
                payload: message,
            });

            return Promise.reject();
        }
    ).catch((error) => {
        dispatch({
            type: UPDATE_EMPLOYEE_PLAN_FAIL,
        });
    }).finally(() => {
        dispatch({
            type: UPDATE_EMPLOYEE_PLAN_FAIL,
        });
    });
};

export const updatePlanStatus = (planId) => async (dispatch) => {
    dispatch({
        type: UPDATE_PLAN_STATUS_PENDING,
        payload: { updatePlanStatus: "isLoading" },
    });
    return await UserService.updatePlanStatus(planId).then(
        (data) => {
            data.data.status ? toast.success(data.data.message, { autoClose: 2000 }) : toast.error(data.data.message, { autoClose: 2000 });
            data.data.status ?
                dispatch({
                    type: UPDATE_PLAN_STATUS_SUCCESS,
                    payload: { updatePlanStatus: data.data.status },
                }) :
                dispatch({
                    type: UPDATE_PLAN_STATUS_FAIL,
                    payload: { updatePlanStatus: data.data.status },
                });
            return Promise.resolve();
        },
        (error) => {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();

            dispatch({
                type: UPDATE_PLAN_STATUS_FAIL,
            });

            dispatch({
                type: SET_MESSAGE,
                payload: message,
            });

            return Promise.reject();
        }
    ).catch((error) => {
        dispatch({
            type: UPDATE_PLAN_STATUS_FAIL,
        });
    }).finally(() => {
        dispatch({
            type: UPDATE_PLAN_STATUS_FAIL,
        });
    });
};

//delete plan
export const deletePlanVisits = (body) => async (dispatch) => {
    dispatch({
        type: DELETE_PLAN_VISITS_PENDING,
        payload: { deletePlanVisits: "isLoading" },
    });
    return await UserService.deletePlanVisits(body).then(
        (data) => {
            data.data.status ? toast.success(data.data.message, { autoClose: 2000 }) : toast.error(data.data.message, { autoClose: 2000 });
            data.data.status ?
                dispatch({
                    type: DELETE_PLAN_VISITS_SUCCESS,
                    payload: { deletePlanVisits: data.data.status },
                }) :
                dispatch({
                    type: DELETE_PLAN_VISITS_FAIL,
                    payload: { deletePlanVisits: data.data.status },
                });
            return Promise.resolve();
        },
        (error) => {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();

            dispatch({
                type: DELETE_PLAN_VISITS_FAIL,
            });

            dispatch({
                type: SET_MESSAGE,
                payload: message,
            });

            return Promise.reject();
        }
    ).catch((error) => {
        dispatch({
            type: DELETE_PLAN_VISITS_FAIL,
        });
    }).finally(() => {
        dispatch({
            type: DELETE_PLAN_VISITS_FAIL,
        });
    });
};

export const resetAddEmployeePlan = () => {
    dispatch({
        type: RESET_ADD_EMPLOYEE_PLAN
    });
}

// approve plan
export const approveEmployeePlan = (planId, statusId, approvedBy) => async (dispatch) => {
    dispatch({
        type: APPROVE_EMPLOYEE_PLAN_PENDING,
        payload: { approveEmployeePlan: "isLoading" },
    });
    return await UserService.approvePlan(planId, statusId, approvedBy).then(
        (data) => {
            data.data.status ? toast.success(data.data.message, { autoClose: 2000 }) : toast.error(data.data.message, { autoClose: 2000 });
            data.data.status ?
                dispatch({
                    type: APPROVE_EMPLOYEE_PLAN_SUCCESS,
                    payload: { approveEmployeePlan: data.data.status },
                }) :
                dispatch({
                    type: APPROVE_EMPLOYEE_PLAN_FAIL,
                    payload: { approveEmployeePlan: data.data.status },
                });
            return Promise.resolve(data.data.status);
        },
        (error) => {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();

            dispatch({
                type: APPROVE_EMPLOYEE_PLAN_FAIL,
            });

            dispatch({
                type: SET_MESSAGE,
                payload: message,
            });

            return Promise.reject();
        }
    ).catch((error) => {
        dispatch({
            type: APPROVE_EMPLOYEE_PLAN_FAIL,
        });
    }).finally(() => {
        dispatch({
            type: APPROVE_EMPLOYEE_PLAN_FAIL,
        });
    });
};

// reject plan
export const rejectEmployeePlan = (planId, statusId, rejectedBy,message) => async (dispatch) => {
    dispatch({
        type: REJECT_EMPLOYEE_PLAN_PENDING,
        payload: { rejectEmployeePlan: "isLoading" },
    });
    return await UserService.rejectPlan(planId, statusId, rejectedBy,message).then(
        (data) => {
            data.data.status ? toast.success(data.data.message, { autoClose: 2000 }) : toast.error(data.data.message, { autoClose: 2000 });
            data.data.status ?
                dispatch({
                    type: REJECT_EMPLOYEE_PLAN_SUCCESS,
                    payload: { rejectEmployeePlan: data.data.status },
                }) :
                dispatch({
                    type: REJECT_EMPLOYEE_PLAN_FAIL,
                    payload: { rejectEmployeePlan: data.data.status },
                });
            return Promise.resolve();
        },
        (error) => {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();

            dispatch({
                type: REJECT_EMPLOYEE_PLAN_FAIL,
            });

            dispatch({
                type: SET_MESSAGE,
                payload: message,
            });

            return Promise.reject();
        }
    ).catch((error) => {
        dispatch({
            type: REJECT_EMPLOYEE_PLAN_FAIL,
        });
    }).finally(() => {
        dispatch({
            type: REJECT_EMPLOYEE_PLAN_FAIL,
        });
    });
};

// create bulk tasks
export const createBulkTasks = (employeeId, month, year) => async (dispatch) => {
    dispatch({
        type: CREATE_BULK_TASKS_PENDING,
        payload: { createBulkTasks: "isLoading" },
    });
    return await UserService.createBulkTasks(employeeId, month, year).then(
        (data) => {
            if (data.data.status) {
                dispatch({
                    type: CREATE_BULK_TASKS_SUCCESS,
                    payload: { createBulkTasks: data.data },
                });
            } else {
                dispatch({
                    type: CREATE_BULK_TASKS_FAIL,
                    payload: { createBulkTasks: data.data.status },
                });
            }
            return Promise.resolve(data.data);
        },
        (error) => {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();

            dispatch({
                type: CREATE_BULK_TASKS_FAIL,
            });

            dispatch({
                type: SET_MESSAGE,
                payload: message,
            });

            return Promise.reject();
        }
    ).catch((error) => {
        dispatch({
            type: CREATE_BULK_TASKS_FAIL,
        });
    });
};
